import React from 'react';
import UTIL from '.';
import Aux from '../components/AuxComponent';
import MUTIL from 'mroads-js-utils';

export default class MenuUtils {
  static parseModifierGroupsToModifiers = (item) => {
    if (!item) return null;
    if (!item.modifierGroups) {
      return null;
    }
    if (item.modifierGroups.length > 0) {
      // eslint-disable-next-line arrow-body-style
      let modifiers = item.modifierGroups.reduce((finalModifiers, modifierGroup) => {
        return finalModifiers.concat(
          MenuUtils.convertModifierGroupToModifier(
            modifierGroup
          ),
        );
      }, []);

      if (modifiers) {
        modifiers = modifiers.filter(modifier => !!modifier);
      }
      return modifiers;
    }
    return null;
  };

  static convertModifierGroupToModifier = modifierGroup => {
    if (!modifierGroup.modifiers) {
      return null;
    }
    const modifiers = [];
    modifierGroup.modifiers.forEach(modifier => {
      if (modifier.selected) {
        const updatedMod = {
          ...modifier,
          modifierGroupId: modifierGroup.id,
        };
        modifiers.push(MenuUtils.getModifiers(updatedMod));
        if (modifier.repeatedModifiers) {
          modifier.repeatedModifiers.forEach(repeatedModifier => {
            const updatedRMod = {
              ...repeatedModifier,
              modifierGroupId: modifierGroup.id,
            };
            modifiers.push(MenuUtils.getModifiers(updatedRMod));
          });
        }
      }
    });
    return modifiers;
  };

  static generateUniqueId = MUTIL.generateUniqueId;

  static getModifiers = (modifier) => {
    let tempModifiers = MenuUtils.parseModifierGroupsToModifiers(modifier);
    if (modifier.modFunction) {
      if (!tempModifiers) {
        tempModifiers = [];
      }
      tempModifiers.push({
        modifiers: null,
        menuItemName: modifier.modFunction.name,
        id: MenuUtils.generateUniqueId(),
        quantity: 1,
        price: MenuUtils.recursivelyGetPrice(modifier.modFunction),
        modifierId: modifier.modFunction.id,
        modifierGroupId: modifier.modifierGroupId ? modifier.modifierGroupId : null,
        note: modifier.note || '',
      });
    }
    return {
      modifiers: tempModifiers,
      menuItemName: modifier.name,
      modifierName: modifier.name,
      id: MenuUtils.generateUniqueId(),
      quantity: 1,
      price: MenuUtils.recursivelyGetPrice(modifier),
      modifierId: modifier.id,
      modifierGroupId: modifier.modifierGroupId ? modifier.modifierGroupId : null,
      note: modifier.note || '',
    };
  };

  static getModifiersWithModFunction = item => {
    if (!item.modifiers) {
      return item.modifiers;
    }
    const tempModifiers = item.modifiers.map(modifier => {
      if (!modifier.modifiers) {
        return {
          ...modifier,
          isModFunction: false,
        };
      }
      if (modifier.modifiers) {
        const obj = {
          ...modifier,
          isModFunction: false,
          modifiers: modifier.modifiers
            .map((m, i) => {
              const modifiers = MenuUtils.getModifiersWithModFunction(m);
              if (!modifiers) {
                return {
                  ...m,
                };
              }
              return modifiers[0];
            })
            .filter(m => !!m),
        };
        return obj;
      }
      return null;
    });
    return tempModifiers;
  };

  static sortModifierFunc = (a, b) => {
    if (a?.modifierId == b?.modifierId) return 0;
    return (a?.modifierId > b?.modifierId) ? 1 : -1;
  };

  static renderModifiersRecursively = (
    item,
    index = 0,
    modifierRenderer,
    itemRenderer,
    checkModifiers,
  ) => {
    let modifierSelection;

    const modifierParser = (i, checkModifiers) => {
      const modifiers = [];
      i.modifiers && Array.isArray(i.modifiers) &&
        // (i.modifiers).sort(this.sortModifierFunc).forEach(m => {
        // sorting by modifier id  
          (i.modifiers).sort(i.modifiers.id).forEach(m => {
          const modifier = MenuUtils.renderModifiersRecursively(
            m,
            index + 1,
            modifierRenderer,
            modifierRenderer,
            checkModifiers,
          );

          modifiers.push(modifier);
          let repeatedModifiers = [];
          if (m.repeatedModifiers) {
            repeatedModifiers = m.repeatedModifiers.map(repeatedModifier =>
              // eslint-disable-next-line implicit-arrow-linebreak
              MenuUtils.renderModifiersRecursively(
                repeatedModifier,
                index + 1,
                modifierRenderer,
                modifierRenderer,
                checkModifiers,
              ),
            );
          }
          modifiers.push(repeatedModifiers);
        });

      return modifiers;
    };

    if (checkModifiers) {
      modifierSelection = modifierParser(item, checkModifiers);
    } else if (item.modifierGroups) {
      modifierSelection = item.modifierGroups.map(mg => modifierParser(mg, checkModifiers));
    }
    return (
      <Aux key={`recursively-render-item${index}${item.id}`}>
        {itemRenderer(item, index)}
        {modifierSelection}
      </Aux>
    );
  };

  static recursivelyGetPrice = item => {
    const modifiers = this.parseModifierGroupsToModifiers(item);
    if (modifiers && modifiers.length > 0) {
      return modifiers
        .map(modifier => {
          // testArray.push[modifier]
          const totalPrice = modifier.price + this.recursivelyGetPrice(modifier);
          return totalPrice;
        })
        .reduce((total, item) => total + item, 0);
    }
    return item.price;
  };

  static getPendingItemsFromCheck = (check: Object) => {
    const pendingItems = [];
    check.orders && check.orders.forEach(order => {
      order.items &&
        order.items.forEach(item => {
          let orderJson = {};
          let modifierJson = {};
          try {
            orderJson = JSON.parse(item.orderJson);
            modifierJson = JSON.parse(orderJson.modifierJson);
          } catch (error) {
            orderJson = {};
            modifierJson = {};
          }
          if (item.pending) {
            pendingItems.push({
              ...orderJson,
              ...modifierJson,
              // checkOrderItemId: item.id,
              modifiers: MenuUtils.getModifiersWithModFunction({
                modifiers: MenuUtils.parseModifierGroupsToModifiers(modifierJson),
              }),
              pending: true,
              ...item,
            });
          }
        });
    });
    return pendingItems;
  };

}
